/* Name repeater for personalised products.

   Rows fade rather than collapse. Earlier versions animated height, and height
   is a layout property: the browser had to re-lay-out everything below the field
   on every frame - the rest of the form, the price, the buy button. That is what
   stuttered, and no amount of tuning fixed it, because the work itself was the
   problem.

   Only opacity and transform are animated now. Both are composited, so they
   cannot trigger layout at all. The row collapses in a single frame once the
   fade has finished. One clean reflow reads as crisp; a long animated one reads
   as broken.

   Hidden rows are also disabled - a hidden-but-enabled input still posts, which
   would put empty 'Name 4' and 'Name 5' properties on every order. */

(function () {
  if (window.__eoNameRepeater) return;
  window.__eoNameRepeater = true;

  var IN = 180;
  var OUT = 130;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function canAnimate() {
    return typeof Element.prototype.animate === 'function' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setRow(row, on) {
    row.hidden = !on;
    var input = row.querySelector('input');
    if (!input) return;
    input.disabled = !on;
    if (!on) input.value = '';
  }

  function stop(row) {
    if (row.getAnimations) row.getAnimations().forEach(function (a) { a.cancel(); });
  }

  function focusRow(row) {
    var input = row.querySelector('input');
    if (!input) return;
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
  }

  function openRow(row) {
    setRow(row, true);
    if (!canAnimate()) { focusRow(row); return; }

    stop(row);
    var anim = row.animate(
      [{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'none' }],
      { duration: IN, easing: EASE }
    );
    anim.onfinish = function () { focusRow(row); };
  }

  function closeRow(row) {
    if (!canAnimate()) { setRow(row, false); return; }

    stop(row);
    var anim = row.animate(
      [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-4px)' }],
      { duration: OUT, easing: 'ease-out', fill: 'forwards' }
    );

    // fill:'forwards' holds the faded-out state until the row is hidden, so it
    // cannot flash back to full opacity for a frame before display:none lands.
    anim.onfinish = function () {
      setRow(row, false);
      anim.cancel();
    };
  }

  function num(list, attr, fallback) {
    var value = parseInt(list.getAttribute(attr) || '', 10);
    return isNaN(value) ? fallback : value;
  }

  function refresh(list) {
    var wrap = list.closest('[data-name-repeater-wrap]');
    if (!wrap) return;
    var shown = num(list, 'data-shown', 2);
    var add = wrap.querySelector('[data-name-add]');
    var remove = wrap.querySelector('[data-name-remove]');
    var count = wrap.querySelector('[data-name-count]');
    if (add) add.disabled = shown >= num(list, 'data-max', 5);
    if (remove) remove.disabled = shown <= num(list, 'data-min', 1);
    if (count) count.textContent = shown === 1 ? '1 name' : shown + ' names';
  }

  function reset(list) {
    var min = num(list, 'data-min', 1);
    var max = num(list, 'data-max', 5);
    var shown = Math.min(Math.max(num(list, 'data-shown', 2), min), max);
    list.setAttribute('data-shown', shown);

    var rows = list.querySelectorAll('[data-name-row]');
    for (var i = 0; i < rows.length; i++) {
      stop(rows[i]);
      setRow(rows[i], i < shown);
    }
    refresh(list);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest('[data-name-add], [data-name-remove]');
    if (!button || button.disabled) return;

    var wrap = button.closest('[data-name-repeater-wrap]');
    if (!wrap) return;
    var list = wrap.querySelector('[data-name-repeater]');
    if (!list) return;

    event.preventDefault();

    var min = num(list, 'data-min', 1);
    var max = num(list, 'data-max', 5);
    var shown = num(list, 'data-shown', 2);
    var adding = button.hasAttribute('data-name-add');

    if (adding ? shown >= max : shown <= min) return;

    var next = adding ? shown + 1 : shown - 1;
    list.setAttribute('data-shown', next);

    var rows = list.querySelectorAll('[data-name-row]');
    var row = rows[adding ? next - 1 : shown - 1];
    if (row) {
      if (adding) openRow(row);
      else closeRow(row);
    }

    refresh(list);
  });

  function initAll() {
    var lists = document.querySelectorAll('[data-name-repeater]');
    for (var i = 0; i < lists.length; i++) reset(lists[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
